import { parse } from 'date-fns';

export default function parseValueToDate(value, format) {
  return parse(value, format, new Date());
}
